import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'bd-object-search-results-loading',
  imports: [SkeletonModule],
  templateUrl: './object-search-results-loading.component.html',
  styleUrl: './object-search-results-loading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectSearchResultsLoadingComponent {}
